function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base';
import Input from '../Input';
import Icon from '../Icon';
import './style.less';
var PAGE_PRE_LEVEL = 5;
var clsPrefix = 'kui-pager';

var PageButton = function PageButton(props) {
  var _classNames;

  var cur = props.cur,
      num = props.num,
      className = props.className,
      disabled = props.disabled;

  var onClick = function onClick() {
    if (!props.disabled) {
      props.onClick(props);
    }
  };

  if (num < 0) {
    return /*#__PURE__*/React.createElement("a", {
      className: "".concat(clsPrefix, "-page-button ").concat(clsPrefix, "-more")
    }, /*#__PURE__*/React.createElement(Icon, {
      iconClass: "kz-e-more"
    }));
  }

  var text = props.children ? props.children : num;
  var cls = classNames("".concat(clsPrefix, "-page-button"), (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-cur"), cur), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _classNames), className);
  return /*#__PURE__*/React.createElement("a", {
    className: cls,
    onClick: onClick,
    role: "button",
    tabIndex: 0
  }, text);
};

PageButton.propTypes = {
  cur: PropTypes.bool,
  num: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func
};
PageButton.defaultProps = {
  cur: false,
  num: 1,
  className: '',
  disabled: false,
  children: null,
  onClick: null
};

var JumpPageButton = function JumpPageButton(_ref) {
  var totalPage = _ref.totalPage,
      onConfirm = _ref.onConfirm;
  var inputValue = '';

  var handleKeyPress = function handleKeyPress(e) {
    if (e.keyCode === 13) {
      var num = parseInt(inputValue, 10);
      if (isNaN(num) || num > totalPage || num < 1) return;
      onConfirm({
        num: num
      });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-jump-page-button")
  }, /*#__PURE__*/React.createElement("span", null, "\u524D\u5F80"), /*#__PURE__*/React.createElement(Input, {
    value: inputValue,
    onKeyPress: handleKeyPress,
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      inputValue = value;
    },
    className: "".concat(clsPrefix, "-page-input")
  }), /*#__PURE__*/React.createElement("span", null, "\u9875"));
};

JumpPageButton.propTypes = {
  totalPage: PropTypes.number.isRequired,
  onConfirm: PropTypes.func.isRequired
};

var Pager = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Pager, _KZUIComponent);

  var _super = _createSuper(Pager);

  function Pager(props) {
    var _this;

    _classCallCheck(this, Pager);

    _this = _super.call(this, props);

    _this.autoBind('handleClick', 'handleInputConfirm', 'handlePageChange', 'getButtons');

    return _this;
  }

  _createClass(Pager, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      return {
        curPage: props.curPage
      };
    }
  }, {
    key: "handlePageChange",
    value: function handlePageChange(num) {
      var _this2 = this;

      this.setState({
        curPage: num
      }, function () {
        if (_this2.props.onPageChange) {
          _this2.props.onPageChange(num);
        }
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(_ref3) {
      var num = _ref3.num;
      this.handlePageChange(num);
    }
  }, {
    key: "handleInputConfirm",
    value: function handleInputConfirm(_ref4) {
      var num = _ref4.num;
      this.handlePageChange(num);
    }
  }, {
    key: "getButtons",
    value: function getButtons() {
      var totalPage = this.props.totalPage;
      var curPage = this.state.curPage;
      var buttons = [];
      var half = Math.floor((PAGE_PRE_LEVEL - 1) / 2);
      var leftPartStart = curPage - half > 0 ? curPage - half : 1;

      if (leftPartStart > 1) {
        buttons.push(1);

        if (leftPartStart > 2) {
          buttons.push(-1);
        }
      }

      for (var i = leftPartStart; i < curPage; i += 1) {
        buttons.push(i);
      }

      var rightPartEnd = curPage + (PAGE_PRE_LEVEL - (curPage - leftPartStart) - 1);
      var lastOne = Math.min(rightPartEnd, totalPage);

      for (var _i = curPage; _i <= lastOne; _i += 1) {
        buttons.push(_i);
      }

      if (rightPartEnd < totalPage) {
        if (rightPartEnd < totalPage - 1) {
          buttons.push(-2);
        }

        buttons.push(totalPage);
      }

      return buttons;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          totalPage = _this$props.totalPage,
          children = _this$props.children;
      var curPage = this.state.curPage;
      var cls = classNames(clsPrefix, className);
      var buttons = this.getButtons();
      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style
      }, children, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-pager-controls")
      }, /*#__PURE__*/React.createElement(PageButton, {
        key: "page-button-prev",
        className: "".concat(clsPrefix, "-prev"),
        num: curPage - 1,
        onClick: this.handleClick,
        disabled: curPage === 1
      }, /*#__PURE__*/React.createElement(Icon, {
        iconClass: "kz-e-drop-left"
      })), buttons.map(function (num) {
        return /*#__PURE__*/React.createElement(PageButton, {
          key: "page-button-".concat(num),
          num: num,
          cur: num === curPage,
          onClick: _this3.handleClick
        });
      }), /*#__PURE__*/React.createElement(PageButton, {
        key: "page-button-next",
        className: "".concat(clsPrefix, "-next"),
        num: curPage + 1,
        onClick: this.handleClick,
        disabled: curPage === totalPage
      }, /*#__PURE__*/React.createElement(Icon, {
        iconClass: "kz-e-drop-right"
      })), totalPage > PAGE_PRE_LEVEL + 2 ? /*#__PURE__*/React.createElement(JumpPageButton, {
        totalPage: totalPage,
        onConfirm: this.handleInputConfirm
      }) : null));
    }
  }]);

  return Pager;
}(KZUIComponent);

Pager.propTypes = {
  totalPage: PropTypes.number.isRequired,
  curPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func
};
Pager.defaultProps = {
  onPageChange: null
};
export default Pager;